import React, { useEffect, useState } from "react";
import Messaging from "./chat";
import "../styles/roomlist.css";
import { Link } from "react-router-dom";

const RoomList = () => {
  const [roomIds, setRoomIds] = useState([]);
  const [selectedRoomId, setSelectedRoomId] = useState(null);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const userId = sessionStorage.getItem("user");
  const token = sessionStorage.getItem("token");

  useEffect(() => {
    const storedRoom = sessionStorage.getItem("autoOpenRoomID");
    if (storedRoom) {
      setSelectedRoomId(storedRoom);
      sessionStorage.removeItem("autoOpenRoomID");
    }
  }, []);

  useEffect(() => {
    const fetchConnections = async () => {
      setIsLoading(true);
      try {
        const [fromRes, toRes] = await Promise.all([
          fetch(`${process.env.REACT_APP_API_PATH}/connections?fromUserID=${userId}`, {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }),
          fetch(`${process.env.REACT_APP_API_PATH}/connections?toUserID=${userId}`, {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }),
        ]);

        const [fromData, toData] = await Promise.all([fromRes.json(), toRes.json()]);
        const allConnections = [
          ...(Array.isArray(fromData[0]) ? fromData[0] : []),
          ...(Array.isArray(toData[0]) ? toData[0] : []),
        ];

        const uniqueConnectionsMap = new Map();
        for (const conn of allConnections) {
          const roomid = conn.attributes?.roomid;
          if (roomid && !uniqueConnectionsMap.has(roomid)) {
            uniqueConnectionsMap.set(roomid, conn);
          }
        }

        const uniqueConnections = Array.from(uniqueConnectionsMap.values());
        setRoomIds(uniqueConnections);
      } catch (err) {
        console.error("❌ Failed to fetch connections:", err);
      } finally {
        setIsLoading(false);
      }
    };


    fetchConnections();
  }, [userId, token]);

  // Empty state component
  const EmptyMessagesState = () => (
    <div className="roomlist-empty-state">
      <div className="roomlist-empty-icon">📬</div>
      <h2>No Messages Yet</h2>
      <p>You don't have any conversations started.</p>
      <p>Visit a user's profile and click the "Message" button to start chatting!</p>
      <Link to="/" className="roomlist-browse-button">
        Browse Users
      </Link>
    </div>
  );

  // Loading state component
  const LoadingState = () => (
    <div className="roomlist-loading-state">
      <p>Loading conversations...</p>
    </div>
  );

  return (
    <div className="roomlist-container">
      {roomIds.length > 0 && (
        <button className="mobile-menu-toggle" onClick={() => setIsMobileMenuOpen((prev) => !prev)}>
          Conversations
        </button>
      )}

      {roomIds.length > 0 && (
        <div className={`roomlist-sidebar ${isMobileMenuOpen ? "open" : ""}`}>
          <ul className="roomlist-ul">
            {roomIds.map((conn) => {
              const otherUser = conn.fromUserID === parseInt(userId)
                ? conn.toUser
                : conn.fromUser;




              const username = otherUser?.attributes?.username || "Unknown";

              return (
                <li key={conn.attributes.roomid}>
                  <button
                    className={`roomlist-button ${selectedRoomId === conn.attributes.roomid ? "active" : ""}`}
                    onClick={() => {
                      setSelectedRoomId(conn.attributes.roomid);
                      setIsMobileMenuOpen(false);
                    }}
                  >
                    {username}
                  </button>
                </li>
              );
            })}
          </ul>
        </div>
      )}
      
      <div className="roomlist-chat-area">
        {isLoading ? (
          <LoadingState />
        ) : roomIds.length === 0 ? (
          <EmptyMessagesState />
        ) : selectedRoomId ? (
          <Messaging roomID={selectedRoomId} />
        ) : (
          <div className="roomlist-placeholder">
            <p>Select a conversation from the list to start chatting</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default RoomList;